import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteBusChassis } from '../../../../actions';

const BusChassisDeleteButton = ({
  dispatchDeleteBusChassis,
  busChassisId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteBusChassis({ busChassisId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

BusChassisDeleteButton.propTypes = {
  dispatchDeleteBusChassis: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  busChassisId: PropTypes.number.isRequired,
};

BusChassisDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteBusChassis: deleteBusChassis,
};

export default connect(null, mapDispatchToProps)(BusChassisDeleteButton);
